import styled from 'styled-components';

const CategoryFilterWrapper = styled.div`
  padding-top: 1px;
`;

export default CategoryFilterWrapper;
